import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import DragDrop from '../DragDrop';
import StackView from '../StackView';
import { composeMultipleEvents } from '../utils';
import { useHover, useKeyboardShortcuts } from '../hooks';

var BodyRow = function BodyRow(_ref) {
  var children = _ref.children,
      keyboardShortcuts = _ref.keyboardShortcuts,
      row = _ref.row,
      rowIndex = _ref.rowIndex,
      onRowSort = _ref.onRowSort,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "keyboardShortcuts", "row", "rowIndex", "onRowSort"]);

  var _useHover = useHover(),
      hover = _useHover.hover,
      hoverProps = _useHover.hoverProps;

  var _useKeyboardShortcuts = useKeyboardShortcuts(keyboardShortcuts, {
    row: row,
    rowIndex: rowIndex
  }),
      bindKeyboardShortcuts = _useKeyboardShortcuts.bindKeyboardShortcuts,
      unbindKeyboardShortcuts = _useKeyboardShortcuts.unbindKeyboardShortcuts;

  var childrenToRender = function childrenToRender(provided) {
    return /*#__PURE__*/React.createElement(StackView, _extends({
      innerRef: provided.innerRef,
      role: "row",
      axis: "horizontal",
      borderColor: "grey-3",
      backgroundColor: "white"
    }, restProps, provided.draggableProps, composeMultipleEvents({
      onMouseEnter: bindKeyboardShortcuts,
      onMouseLeave: unbindKeyboardShortcuts
    }, hoverProps)), children({
      isRowHovered: hover,
      dragHandleProps: provided.dragHandleProps
    }));
  };

  if (onRowSort) {
    return /*#__PURE__*/React.createElement(DragDrop.Draggable, {
      draggableId: rowIndex.toString(),
      index: rowIndex
    }, function (provided) {
      return childrenToRender(provided);
    });
  } else {
    return childrenToRender({});
  }
};

export default BodyRow;